export const QUESTION_SET_RESULT = 'QUESTION_SET_RESULT'
export const QUESTION_SET_CURRENT = 'QUESTION_SET_CURRENT'
export const QUESTION_SET_LAST = 'QUESTION_SET_LAST'
export const QUESTION_GO_BACK = 'QUESTION_GO_BACK'
export const CONVERT_QUESTIONS_TO_SETTINGS = 'CONVERT_QUESTIONS_TO_SETTINGS'

export function setQuestionResult(index, value) {
    return {
        type: QUESTION_SET_RESULT,
        index,
        payload: value,
    }
}

export function setCurrentQuestion(index) {
    return {
        type: QUESTION_SET_CURRENT,
        payload: index,
    }
}

export function setPrevQuestion(index) {
    return {
        type: QUESTION_SET_LAST,
        payload: index,
    }
}

export function goQuestionBack() {
    return {
        type: QUESTION_GO_BACK,
        payload: {},
    }
}

export function convertIntroQuestionsToSettings(questions) {
    return {
        type: CONVERT_QUESTIONS_TO_SETTINGS,
        payload: questions,
    }
}



// WEBPACK FOOTER //
// ./src/actions/questions.js